import React, { useRef, useState } from "react";

const ImageUploadSplitCanvas = ({ defaultImage, onChange, className,index}) => {
  //   const [imagePreview, setImagePreview] = useState(defaultImage);
  const [imageParts, setImageParts] = useState([]);
  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };
 
  // Function to handle image selection and splitting
  const handleImageSelect = (event) => {
    const file = event.target.files[0];
    setimageloading(true);
    const reader = new FileReader();

    reader.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const partWidth = image.width / 3;
        const partHeight = image.height;

        canvas.width = partWidth;
        canvas.height = partHeight;

        const parts = [];

        for (let i = 0; i < 3; i++) {
          ctx.drawImage(
            image,
            i * partWidth,
            0,
            partWidth,
            partHeight,
            0,
            0,
            partWidth,
            partHeight
          );
          parts.push(canvas.toDataURL());
        }

        setImageParts(parts);
      };
    };

    if (file) {
      reader.readAsDataURL(file);
    }
    onChange && onChange(file);
  };

  const [imageloading, setimageloading] = useState(false);

  const handleImageLoad = () => {
    setimageloading(false);
  };

  return (
  
    <div className="control-group file-upload">
      <div className="image-box">
        {console.log(imageParts)}
        {imageloading && (
          <div
            className={`align-items-center d-flex justify-content-center ${className}`}
          >
            <i
              className="fa fa-spinner fa-pulse fa-2x fa-fw"
              style={{ animationDuration: "1.5s" }}
            ></i>
          </div>
        )}
        <img
          src={ imageParts[index] || defaultImage}
          alt={`Part ${index+1}`}
          onClick={handleImageClick}
          className={`${imageloading ? "d-none" : "d-block"} ${className}`}
          onLoad={handleImageLoad}
        />
      </div>
      <div className="controls" style={{ display: "none" }}>
        <input
          type="file"
          accept="image/png, image/jpeg"
          onChange={handleImageSelect}
          ref={fileInputRef}
          style={{ display: "none" }}
        />
      </div>
    </div>
        
 
  );
};

export default ImageUploadSplitCanvas;
